import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditItineraryButton from './EditItineraryButton';
import StatusItineraryButton from './StatusItineraryButton';
import PrintDropdownButton from '../PrintDropdownButton';
import PrintFuelVoucherButton from '../PrintFuelVoucherButton';
import PrintExpenseButton from '../PrintExpenseButton';
import QualityControlButton from './QualityControlButton';
import BaggageItemMovementButton from './BaggageItemMovementButton';
import ItinerarySendGrtButton from '../../itinerary/itinerary/ItinerarySendGrtButton';
import ItinerarySendGrrButton from '../../itinerary/itinerary/ItinerarySendGrrButton';
import ViewGuidesButton from '../billings-for-itinerary/ViewGuidesButton';
import DeleteBillingsByItineraryButton from '../billings-for-itinerary/DeleteBillingsByItineraryButton';
import ItineraryMassivePostponeButton from '../itinerary/ItineraryMassivePostponeButton';
import AddItineraryFoodButton from '../itinerary-food/AddItineraryFoodButton';
import DeleteItineraryFoodButton from '../itinerary-food/DeleteItineraryFoodButton';
import ItineraryFoodButton from '../itinerary-food/ItineraryFoodButton';
import DeleteItineraryAdditionalFoodButton from '../itinerary-food/DeleteItineraryAdditionalFoodButton';
import ReprintFuelVoucherButton from '../ReprintFuelVoucherButton';

const ItineraryForCounterToolbar = ({ itineraryId, drivers }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <BaggageItemMovementButton itineraryId={itineraryId} />{' '}
      <QualityControlButton itineraryId={itineraryId} /> <PrintDropdownButton />{' '}
      <PrintExpenseButton drivers={drivers} /> <PrintFuelVoucherButton /> <ReprintFuelVoucherButton />{' '}
      <StatusItineraryButton />{' '}
      <EditItineraryButton itineraryId={itineraryId} />{' '}
      <ItinerarySendGrtButton itineraryId={itineraryId} useV2 />{' '}
      <ItinerarySendGrrButton itineraryId={itineraryId} useV2 />{' '}
      <DeleteBillingsByItineraryButton itineraryId={itineraryId} />{' '}
      <ItineraryMassivePostponeButton itineraryId={itineraryId} />{' '}
      <ViewGuidesButton itineraryId={itineraryId} />{' '}
      <ItineraryFoodButton itineraryId={itineraryId} />{' '}
      <AddItineraryFoodButton itineraryId={itineraryId} />{' '}
      <DeleteItineraryFoodButton itineraryId={itineraryId} />{' '}
      <DeleteItineraryAdditionalFoodButton itineraryId={itineraryId} />
    </div>
  </ButtonToolbar>
);

ItineraryForCounterToolbar.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  drivers: PropTypes.instanceOf(Immutable.Set).isRequired,
};

export default ItineraryForCounterToolbar;
